import React, { cloneElement, forwardRef, useId } from 'react';
import { uiText } from '../../i18n/uiText';

// Presentational only: values, validation rules and submission remain owned by
// the existing screen. The field owns the label/help/error association.
export default function FormField({ label, hint, error, required, children, className = '' }) {
  const generatedId = useId();
  const id = children.props.id || generatedId;
  const descriptions = [children.props['aria-describedby'], hint ? `${id}-hint` : '', error ? `${id}-error` : ''].filter(Boolean).join(' ') || undefined;
  const isRequired = required || children.props.required;
  return <div className={`ap-field ${className}`}>
    <label htmlFor={id}>{uiText(label)}{isRequired && <span aria-hidden="true" className="ap-field__required"> *</span>}</label>
    {cloneElement(children, {id, required:isRequired, 'aria-describedby':descriptions, 'aria-invalid':error ? true : children.props['aria-invalid']})}
    {hint && <div className="ap-field__hint" id={`${id}-hint`}>{uiText(hint)}</div>}
    {error && <div className="ap-field__error" id={`${id}-error`} role="alert">{uiText(error)}</div>}
  </div>;
}
export const TextInput = forwardRef(({className='', ...props},ref) => <input {...props} ref={ref} className={`ap-control ${className}`} />);
export const SelectInput = forwardRef(({className='', ...props},ref) => <select {...props} ref={ref} className={`ap-control ${className}`} />);
export const TextArea = forwardRef(({className='', ...props},ref) => <textarea {...props} ref={ref} className={`ap-control ${className}`} />);
